import React from "react";
import { transformToHtml, getBackgroundImage } from "../../../utils/CommonUtils";
import { getBackgroundColor } from "../../../utils/FlightStatusUtils";

export default function RouteBar({ data }) {
  if (!data) return null;

  return (
    <div className="flexCol gap6">
      <div className="makeFlex spaceBetween bottom">
        {data.startUpInfo?.icon && (
          <span className="bgProperties icon16" style={getBackgroundImage(data.startUpInfo.icon)} />
        )}
        {data.midUpInfo && (
          <div
            className="fsd-status-tag ontime fontSize12 boldFont"
            style={{
              borderColor: data.midUpInfo.borderColors?.[0] || "#007e7d",
            }}
          >
            {transformToHtml(data.midUpInfo.text)}
          </div>
        )}
        {data.endUpInfo?.icon && (
          <span className="bgProperties icon16" style={getBackgroundImage(data.endUpInfo.icon)} />
        )}
      </div>
      {data.bgColors && (
        <div className="fsd-routebar-bar br4" style={getBackgroundColor(data.bgColors)} />
      )}
      {data.midDownInfo?.text && (
        <div className="fontSize14 boldFont darkText textCenter">
          {transformToHtml(data.midDownInfo.text)}
        </div>
      )}
      {data.description && (
        <div className="fontSize12 textCenter">{transformToHtml(data.description)}</div>
      )}
    </div>
  );
}
